module.exports = __webpack_public_path__ + "static/media/favorit-ikon.5c1e01e6.png";